<template>
  <li
    class="hiq-detail-planning-list__checkbox-wrapper"
    :class="{ selected: selected }"
    v-if="group === 'statusFilter' || selected || hitsLength > 0"
  >
    <input
      class="hiq-detail-planning-list__checkbox-input"
      type="checkbox"
      :id="'value-' + group + '-' + filter.id"
      v-model="selected"
      autocomplete="off"
    />
    <span
      class="hiq-detail-planning-list__checkbox-custom"
      :class="{ selected: selected }"
    ></span>
    <label
      class="hiq-detail-planning-list__checkbox-label"
      :class="{ selected: selected }"
      :for="'value-' + group + '-' + filter.id"
      tabindex="0"
      role="button"
      :aria-pressed="selected"
      @keyup="toggleSelected"
    >
      {{ filter.name }} ({{ hitsLength }})
    </label>
  </li>
</template>
<script lang="ts">
import Vue, { PropType } from "vue";
import { FilterGroup, toggleFilter } from "../store/actions";
import { IFilter, ISearchHit } from "../store/state";

interface CheckboxProperty {
  filter: IFilter;
  group: FilterGroup;
}
interface CheckboxComputed {
  selected: boolean;
  hitsLength: number;
}
interface CheckboxMethods {
  toggleSelected(e: KeyboardEvent): void;
}
export default Vue.extend<{}, CheckboxMethods, CheckboxComputed, CheckboxProperty>({
  name: "Checkbox",
  props: {
    filter: {
      type: Object,
      required: true,
    },
    group: {
      type: String as PropType<FilterGroup>,
      required: true,
    },
  },
  methods: {
    toggleSelected(e) {
      if (e.key !== "Enter") {
        return;
      }

      const filter = this.$store.getters[this.$props.group].find(
        (candidate: IFilter) => candidate.id === this.$props.filter.id
      );

      if (filter) {
        this.$store.dispatch(
          toggleFilter({
            group: this.$props.group,
            id: filter.id,
            value: !filter.selected,
          })
        );
      }
    },
  },
  computed: {
    selected: {
      get() {
        const filter = this.$store.getters[this.$props.group].find(
          (candidate: IFilter) => candidate.id === this.$props.filter.id
        );
        return filter ? filter.selected : false;
      },
      set(value: boolean) {
        this.$store.dispatch(
          toggleFilter({
            group: this.$props.group,
            id: this.$props.filter.id,
            value,
          })
        );
      },
    },
    hitsLength() {
      const searchHits = this.$store.getters.searchResult.searchHits;

      if (this.$props.group === "areaFilter") {
        const selectedStatuses = this.$store.getters.statusFilter.filter(
          (filter: IFilter) => filter.selected
        );
        const areaHits = searchHits[this.$props.filter.name] || [];

        return areaHits.filter((hit: ISearchHit) => {
          return (
            selectedStatuses.length === 0 ||
            selectedStatuses.some(
              (filter: IFilter) => filter.name === hit.status
            )
          );
        }).length;
      }

      const selectedAreas = this.$store.getters.areaFilter.filter(
        (filter: IFilter) => filter.selected
      );
      let amount = 0;

      Object.keys(searchHits).forEach((area) => {
        const areaMatches =
          selectedAreas.length === 0 ||
          selectedAreas.some((filter: IFilter) => filter.name === area);

        if (areaMatches) {
          amount += searchHits[area].filter(
            (hit: ISearchHit) => hit.status === this.$props.filter.name
          ).length;
        }
      });

      return amount;
    },
  },
});
</script>
